export class PageRequest {
  public page?: number = 1;
  public all?: boolean;
}
